import styled from 'styled-components';
import { TextStyles } from '@/constants';
import { Button, Typography } from '@/components';
import { ButtonVariant } from '@/interfaces';

export const ServiceTitle = styled(Typography).attrs({
  variant: TextStyles['Heading 3'],
})`
  color: ${({ theme }) => theme.colors.darkBlue};
  -webkit-box-orient: vertical;
  overflow: hidden;
  -webkit-line-clamp: 1;
  display: -webkit-box;
  text-align: center;

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    text-align: left;
  }
`;

export const ServiceSubTitle = styled(Typography).attrs({
  variant: TextStyles['Body Text Large'],
})`
  color: ${({ theme }) => theme.colors.highEmphasisBlack};
  margin-top: ${({ theme }) => theme.spacing[8]};
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  overflow: hidden;

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    margin-top: ${({ theme }) => theme.spacing[16]};
  }
`;

export const ServicesButton = styled(Button).attrs({
  variant: ButtonVariant.Outlined,
})`
  margin-top: ${({ theme }) => theme.spacing[8]};
  padding: ${({ theme }) => theme.spacing[10]};
  width: 100%;

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    margin-top: ${({ theme }) => theme.spacing[16]};
    padding: ${({ theme }) => theme.spacing[16]};
    width: fit-content;
  }
`;

export const ServicesContentWrapper = styled.div`
  display: flex;
  flex-direction: column;

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    padding: ${({ theme }) => `${theme.spacing[64]} ${theme.spacing[32]}`};
  }
`;

export const ImageWrapper = styled.div`
  width: 100%;
  height: 180px;
  position: relative;
  display: block;
  margin-bottom: ${({ theme }) => theme.spacing[32]};

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    margin-bottom: 0;
    width: 100%;
    height: 360px;
  }
`;

export const ServicesContainer = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;

  :not(:last-child) {
    margin-bottom: ${({ theme }) => theme.spacing[32]};
  }

  ${({ theme }) => theme.mediaBreakpointUp.md} {
    flex-direction: row;

    > * {
      flex-basis: 50%;
    }

    :not(:last-child) {
      margin-bottom: ${({ theme }) => theme.spacing[16]};
    }

    &:nth-child(2n + 1) {
      ${ServicesContentWrapper} {
        order: 1;
      }
      ${ImageWrapper} {
        order: 2;
      }
    }

    :nth-child(2n) {
      ${ServicesContentWrapper} {
        order: 2;
      }
      ${ImageWrapper} {
        order: 1;
      }
    }
  }
`;
